import React from 'react';
import { useStyles } from './styles';
import { CaretDownOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const SelectedBar = ({
  onClick,
  checkedFilters,
  placeholderInfo,
  isShowFilterTable,
  hasBorder,
}) => {
  const { title, filteredTitle } = placeholderInfo;
  const classes = useStyles();

  return (
    <button
      onClick={onClick}
      className={classNames({
        [classes.header]: hasBorder,
        [classes.noborderHeader]: !hasBorder,
        [classes.selectColor]: checkedFilters?.length > 0,
      })}
    >
      {checkedFilters?.length === 0 ? title : `${filteredTitle}  · ${checkedFilters?.length}`}
      <CaretDownOutlined
        className={`${classes.filterSvg} ${isShowFilterTable ? classes.svgRotate : ''} 
        ${checkedFilters?.length !== 0 ? classes.highLight : ''}`}
      />
    </button>
  );
};

export default SelectedBar;
